<template>
  <div>
    <p class="mt-2 mb-0">
      La espera corre desde lo más tarde entre la llegada del repartidor y la
      salida programada, hasta que inicia la ruta. Se descuentan
      {{ details.toleranceMinutes }} min de tolerancia.
    </p>
    <ContentMetrics>
      <template>
        <Metric :value="details.totalRoutes" :title="'Rutas totales'" :border="true" />
        <Metric :value="details.totalRoutesWithExcess" :title="'Rutas con demora'" :border="true" />
        <Metric :value="averageLabel" :title="'Exceso promedio (min)'" :border="true" />
        <Metric :value="notCountedRoutes" :title="'No cuentan'" :border="true" />
        <Metric :value="details.score" :title="'Score'" />
      </template>
    </ContentMetrics>
    <div class="mt-4 mb-4 content-table-level">
      <el-table
        v-if="hasRoutes"
        :data="details.routes"
        row-key="id"
        header-row-class-name="thead-desing-dark"
        class="desing-dark dealer-wait-table"
      >
        <el-table-column label="Fecha" prop="date" min-width="90px" />
        <el-table-column label="Ruta Asignada" prop="route" min-width="116px">
          <template v-slot="{ row }"><strong>{{ row.route }}</strong></template>
        </el-table-column>
        <el-table-column label="Salida programada" prop="scheduled_departure_time" min-width="110px" />
        <el-table-column label="Llegada" prop="arrival_time" min-width="95px" />
        <el-table-column label="Inicio de ruta" prop="route_started_time" min-width="100px" />
        <el-table-column label="Espera (min)" prop="wait_minutes" min-width="95px" align="right">
          <template v-slot="{ row }">{{ describeWait(row) }}</template>
        </el-table-column>
        <el-table-column label="Exceso (min)" prop="excess_minutes" min-width="105px" align="right">
          <template v-slot="{ row }">{{ describeExcess(row) }}</template>
        </el-table-column>
        <el-table-column label="Estado" prop="status" min-width="160px">
          <template v-slot="{ row }"><DealerWaitStatusTag :status="describeRouteStatus(row)" /></template>
        </el-table-column>
      </el-table>
    </div>
    <DealerWaitStatusLegend v-if="hasRoutes" />
  </div>
</template>
<script>
import { Table, TableColumn } from "element-ui";
import ContentMetrics from "@/components/Levels/ContentMetrics";
import Metric from "@/components/Levels/Metric";
import { NO_WAIT_MARKS_LABEL } from "@/utils/dealerWaitThresholds";
import DealerWaitStatusTag from "@/components/EsperaRepartidor/DealerWaitStatusTag";
import DealerWaitStatusLegend from "@/components/EsperaRepartidor/DealerWaitStatusLegend";
import { describeWait, describeExcess, countNotCountedRoutes } from "@/utils/dealerWaitRows";
import { describeRouteStatus } from "@/utils/dealerWaitRouteStatus";

const NO_ROUTES = 0;

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    ContentMetrics,
    Metric,
    DealerWaitStatusTag,
    DealerWaitStatusLegend
  },
  props: {
    details: {
      type: Object,
      required: true
    }
  },
  computed: {
    averageLabel() {
      return this.details.averageWaitExcessMinutes === null
        ? NO_WAIT_MARKS_LABEL
        : this.details.averageWaitExcessMinutes;
    },
    hasRoutes() {
      return this.details.routes.length > NO_ROUTES;
    },
    notCountedRoutes() {
      return countNotCountedRoutes(this.details.routes);
    }
  },
  methods: {
    describeWait,
    describeExcess,
    describeRouteStatus
  }
};
</script>
